import useSWR from 'swr';
import { customSWRConfig, customSWRResponse, IForm } from '../../model/types';
import { usePublicApiSWRCacheKeys } from '../useSWRCacheKeys';

export default function useEndUserFormById(id: string, config: customSWRConfig = {}): customSWRResponse<IForm> {
    const keys = usePublicApiSWRCacheKeys(id ? `/user-forms/${id}` : null);

    return useSWR<IForm>(keys, { ...config });
}
